<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';

import {
  required,
  //email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Industry",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      title: "Industry",
      componentKey: 0,
      items: [
        {
          text: "Management",
          href: "/"
        },
        {
          text: "Industries",
          href: "/management/industries"
        },
        {
          text: "Industry",
          active: true
        }
      ],
      form: {
        nm_industry: "",
      },
      submitted: false,
      user: {},
      industries: []
    };
  },
  validations: {
    form: {
      nm_industry: {required, minLength: minLength(2), maxLength: maxLength(50)},
    }
  },
  watch:{},
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    if( this.$route.params.id ){
      this.id_industry = this.$route.params.id;
      this.getIndustryByID( this.$route.params.id );
    }
    appConfig.title = function(){
      return "dsdas";
    };
  },
  methods: {
    getIndustryByID(idIndustry){
      let app = this;

      Swal.fire({
        title: "Loading industry data.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });


      axios
      .get(
        window.serverPath+'dist/mvw/controllers/industries.php',
        {
          params: {
            request: 'getIndustryByID',
            id: idIndustry
          }
        }
      )
      .then(response => {
        console.log(response);
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.nm_industry = response.data.nm_industry;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    // eslint-disable-next-line no-unused-vars
    saveIndustry(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_industry = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving industry.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/industries.php', {
          request: 'saveIndustry',
          data: this.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The industry is correct "+action+"!", "success");
          app.$router.push({ name: 'industries' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                app.$router.push({ name: 'industries'});
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });

        /*
        Swal.fire("Good job!", "Your industry is saved now!", "success")
        .then(() => {
          self.submitted = false;
          self.form.id_industry       = "";
          self.form.nm_industry = "";
        });
        */
      }
    },

    resetSite(){
      this.form.nm_industry = "";
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveIndustry">
              <div class="row">
                <div class="col-lg-4" >
                  <h4 class="card-title">Industry</h4>
                  <p class="card-title-desc">Register a new industry into the system.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nm_industry">Industry name</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_industry.$error }"
                          name="nm_industry"
                          id="nm_industry"
                          v-model="form.nm_industry"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_industry.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_industry.required">Industry name is required.</span>
                          <span v-if="!$v.form.nm_industry.minLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                          <span v-if="!$v.form.nm_industry.maxLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                </div>

                <div class="col-lg-4">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE INDUSTRY</button>
                    <router-link to="/management/industries" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>